<form [formGroup]="myFilesManager.fileUploadForm" class="d-flex m-5  flex-column ">
  <app-input-field class='my-2' *ngIf='teamInputFieldObject'
    [allowedValueUpdate]='teamInputFieldObject.retrieved_allowed_values'
    [valueUpdate]='teamInputFieldObject.retrievedValue' [parentForm]='myFilesManager.fileUploadForm'
    [inputJson]='teamInputFieldObject'>
  </app-input-field>
  <app-input-field class='my-2' [parentForm]='myFilesManager.fileUploadForm' [writeError]='true'
    [inputJson]='fileInputFieldObject'></app-input-field>
</form>
